import { useEffect, useRef } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import WhoWeServe from './components/WhoWeServe';
import WhyItMatters from './components/WhyItMatters';
import Contact from './components/Contact';
import PrivacyPolicy from './components/PrivacyPolicy';
import Footer from './components/Footer';

export default function HomePage() {
  const sectionsRef = useRef<(HTMLElement | null)[]>([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.05,
      rootMargin: '0px 0px 0px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    sectionsRef.current.forEach((section) => {
      if (section) {
        observer.observe(section);
      }
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="bg-[#F8F6F3]">
      <Hero ref={(el) => (sectionsRef.current[0] = el)} />
      <About ref={(el) => (sectionsRef.current[1] = el)} />
      <Services ref={(el) => (sectionsRef.current[2] = el)} />
      <WhoWeServe ref={(el) => (sectionsRef.current[3] = el)} />
      <WhyItMatters ref={(el) => (sectionsRef.current[4] = el)} />
      <Contact ref={(el) => (sectionsRef.current[5] = el)} />
      <PrivacyPolicy ref={(el) => (sectionsRef.current[6] = el)} />
      <Footer />
    </div>
  );
}